import { EyeClosed } from '../../../../icons/utility/EyeClosed';
import { EyeOpen } from '../../../../icons/utility/EyeOpen';
import { Icon } from './Icon';

export function PasswordMaskIcon({
  isPasswordInput,
  passwordMasked,
  onToggle,
}: {
  isPasswordInput: boolean;
  passwordMasked: boolean;
  onToggle: () => void;
}) {
  if (!isPasswordInput) {
    return null;
  }

  return (
    <Icon
      ariaLabel={`${passwordMasked ? 'Show' : 'Hide'} Password`}
      icon={passwordMasked ? <EyeOpen /> : <EyeClosed />}
      action={onToggle}
    />
  );
}
